"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneMutedOutlineYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneMutedOutlineYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.439 8.44a9.787 9.787 0 0 1-.9-1.493.882.882 0 0 1 .183-1.002l.72-.72c.5-.5.78-1.178.78-1.885V1.778C6.222.796 5.426 0 4.445 0H2.667A2.66 2.66 0 0 0 .782.782 2.66 2.66 0 0 0 0 2.666a13.28 13.28 0 0 0 2.902 8.31l.712-.712A12.284 12.284 0 0 1 1 2.667c0-.458.187-.874.49-1.176A1.66 1.66 0 0 1 2.667 1h1.778c.43 0 .777.348.777.778V3.34c0 .442-.175.866-.488 1.178l-.719.72c-.538.538-.741 1.397-.375 2.148.305.626.669 1.218 1.084 1.769l.52-.52.195-.195ZM5.365 9.928l.673-.673.035-.035a9.816 9.816 0 0 0 2.98 2.242c.116.056.24.084.365.084a.907.907 0 0 0 .637-.268l.72-.719c.5-.5 1.178-.781 1.886-.781h1.561c.982 0 1.778.796 1.778 1.777v1.779c0 1.44-1.145 2.657-2.585 2.666h-.081c-3.865 0-7.343-1.64-9.778-4.263l.708-.708A12.299 12.299 0 0 0 13.334 15h.078c.857-.007 1.588-.745 1.588-1.666v-1.779a.778.778 0 0 0-.778-.777h-1.561c-.443 0-.866.175-1.178.488h-.001l-.72.72a1.92 1.92 0 0 1-1.344.56c-.27 0-.546-.06-.805-.186a10.8 10.8 0 0 1-3.248-2.432Z",
    fill: "#000001"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneMutedOutlineYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131619",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneMutedOutlineYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.854.146a.5.5 0 0 1 0 .708l-15 15a.5.5 0 0 1-.708-.708l15-15a.5.5 0 0 1 .708 0Z",
    fill: "#F21F31"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneMutedOutlineYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F21F31",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneMutedOutlineYes;
exports["default"] = _default;